module.exports = __webpack_public_path__ + "img/earth.e08bb765.png";